<template>
  <div>
    <h4 class="title is-4">Voeg {{ type }} Toe</h4>
    <form action ref="tableRef">
      <b-field grouped>
        <b-field label="Aantal">
          <b-input placeholder="1" type="number" min="1" max="10" required v-model="number"></b-input>
        </b-field>
        <b-field label="Voorvoegsel" expanded>
          <b-input type="text" :placeholder="'Voorbeeld_' + type" :input="type" v-model="prefix"></b-input>
        </b-field>
        <b-field label="Nummeringtype">
          <b-select required placeholder="123" v-model="style" icon="list-ol" icon-pack="fas" @input="beginWith()">
            <option v-for="option in numbers" :key="option.id">{{ option.value }}</option>
          </b-select>
        </b-field>

        <b-field label="Achtervoegsel">
          <b-input type="text" placeholder="..." v-model="suffix"></b-input>
        </b-field>
        <b-field label="Beginnen bij ">
          <b-input
            placeholder="1"
            :pattern="patternStartValue"
            type="text"
            oninvalid="this.setCustomValidity('Hou aan nummeringstype')"
            onchange="this.setCustomValidity('')"
            v-model="startValue"
          ></b-input>
        </b-field>
        <b-field label="Voeg Toe">
          <button class="button" type="button" @click="insertData">Voeg Toe</button>
        </b-field>
      </b-field>
    </form>

    <b-table
      v-sortable="sortableOptions"
      :data="data"
      :selected.sync="selected"
      :checked-rows.sync="checkedRows"
      checkable
    >
      <template>
        <b-table-column field="order" label="ID" width="40" numeric v-slot="props">{{
          props.row.order
        }}</b-table-column>

        <b-table-column :field="type + '_name'" :label="'Naam ' + type" v-slot="props">
          {{ props.row.name }}
          <span class="handle">
            <span class="icon">
              <i class="fas fa-grip-vertical"></i>
            </span>
          </span>
        </b-table-column>
      </template>
      <template slot="bottom-left">
        <b>Totaal Geselecteerde Rijen</b>
        : {{ checkedRows.length }}
        <span style="padding-left: 20px">
          <button
            class="button field is-danger"
            @click="
              deleteRows(checkedRows)
              checkedRows = []
            "
            :disabled="!checkedRows.length"
          >
            <b-icon icon="close"></b-icon>
            <span>Delete Selectie</span>
          </button>
        </span>
      </template>
    </b-table>
  </div>
</template>

<script>
import Sortable from 'sortablejs'
const createSortable = (el, options, vnode) => {
  let orders = []
  return Sortable.create(el, {
    ...options,
    onEnd: function (evt) {
      if (vnode.context.update && vnode.context.modified) {
        const n = orders.length
        const N = vnode.context.data.length
        for (let i = n; i < N; i++) {
          orders.splice(i, 0, vnode.context.data[i].norder)
        }
      } else if (vnode.context.update && !vnode.context.modified) {
        // Create an array of orders
        orders = []
        orders = vnode.context.data.map(obj => obj.norder)
        vnode.context.update = false
      }
      const data = vnode.context.data

      // Update the position of the objects
      orders.splice(evt.newIndex, 0, ...orders.splice(evt.oldIndex, 1))

      // Change the order parameter
      data.forEach(obj => {
        obj.order = orders.findIndex(n => n === obj.norder) + 1
      })
      vnode.context.modified = true
    }
  })
}
const sortable = {
  name: 'sortable',
  bind(el, binding, vnode) {
    const table = el.querySelector('table')
    table._sortable = createSortable(table.querySelector('tbody'), binding.value, vnode)
  }
}

export default {
  directives: { sortable },
  props: ['type', 'data'],
  data() {
    return {
      sortableOptions: {
        chosenClass: 'is-selected',
        handle: '.handle'
      },
      selected: {},
      radio: 'default',
      land: 'Nederland',
      organisatie: 'Atlas Techrin International',
      numbers: [
        { key: 1, value: 'ABC' },
        { key: 2, value: '123' },
        { key: 3, value: 'abc' },
        { key: 4, value: 'none' }
      ],
      checkedRows: [],
      update: false,
      modified: false,
      number: null,
      prefix: '',
      style: null,
      suffix: '',
      startValue: '',
      patternStartValue: '',
      deletedRows: []
    }
  },
  methods: {
    beginWith() {
      if (this.style == 'ABC') {
        this.startValue = 'A'
        this.patternStartValue = '[A-Z]{1}'
      } else if (this.style == 'abc') {
        this.startValue = 'a'
        this.patternStartValue = '[a-z]{1}'
      } else if (this.style == '123') {
        this.startValue = '1'
        this.patternStartValue = '[0-9]{1,2}'
      } else {
        this.startValue = ''
        this.patternStartValue = ''
      }
    },
    insertData() {
      let i
      let n
      const inputref = this.$refs.tableRef.getElementsByTagName('input')
      const selectref = this.$refs.tableRef.getElementsByTagName('select')
      let hasError = false

      for (let i = 0; i < inputref.length; i++) {
        if (!inputref[i].validity.valid) {
          hasError = true
        }
      }
      for (let i = 0; i < selectref.length; i++) {
        if (!selectref[i].validity.valid) {
          hasError = true
        }
      }
      if (!hasError) {
        if (this.data != [] && this.data[0].name === `Voorbeeld ${this.type} 1`) {
          this.data.shift()
        }
        for (i = 1; i <= this.number; i++) {
          if (this.style === 'ABC') {
            n = String.fromCharCode(this.startValue.charCodeAt(0) - 1 + i)
          } else if (this.style === 'abc') {
            n = String.fromCharCode(this.startValue.charCodeAt(0) - 1 + i)
          } else if (this.style === '123') {
            n = parseInt(this.startValue) - 1 + i
          } else {
            n = ''
          }
          this.data.push({
            order: this.data.length + 1,
            norder: this.data.length,
            name: `${this.prefix}${n}${this.suffix}`
          })
        }
      }
      this.update = true
    },
    deleteRows(checkedRows) {
      const rows = []
      for (let i = 0; i < this.checkedRows.length; i++) {
        rows.push(checkedRows[i])
      }
      rows.forEach(o => {
        const index = this.data.findIndex(i => i.name === o.name)
        for (let j = index; j < this.data.length; j++) {
          this.data[j].order = this.data[j].order - 1
        }
        this.data.splice(index, 1)
      })
      this.update = true
    }
  }
}
</script>

<style lang="scss">
.handle {
  display: inline-block;
  padding-bottom: 5px;
  height: 24px;
  width: 24px;
  color: gray;
  background-color: transparent;
  cursor: move;
  vertical-align: bottom;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/Projects/NamingTable.vue